/**
 * isDebugSurface — the shared predicate for "is this a diagnostic surface?"
 *
 * Only the `/debug` route (or an explicit `?debug=1`, or `playwrightTest` for
 * E2E) is a debug surface. Clean play surfaces are not unless the operator
 * explicitly adds the debug flag. This lives in shared diagnostics so gameplay
 * diagnostics and UI infrastructure can consume the same route decision
 * without crossing UI architecture seams.
 *
 * Deliberately not gated on `window.forceDebug`: that flag describes the
 * environment/build, not the current route, and is true across PTR.
 */
import { bootPathname, bootSearchParams } from '../../config/boot/bootUrl';
export function isDebugSurface(): boolean {
  if (typeof window === 'undefined') return false;
  if ((window as any).playwrightTest) return true;
  try {
    if (bootPathname().startsWith('/debug')) return true;
    if (bootSearchParams().get('debug') === '1') return true;
  } catch { /* ignore */ }
  return false;
}
